<h1 class="mb-8 text-2xl outline-0" tabindex="0">
  {{ 'USER_PAGE.STEPPER.PRIVACY_FORM.TITLE' | translate }}
</h1>
<ul class="space-y-4">
  <li class="flex items-baseline">
    <span class="mr-2 font-semibold">
      {{ 'USER_PAGE.STEPPER.PRIVACY_FORM.FIELDS.BADGE_NUMBER' | translate }}
    </span>
    {{ currentUser?.details?.badgeNumber }}
  </li>
  <li class="flex items-baseline">
    <span class="mr-2 font-semibold">
      {{ 'USER_PAGE.STEPPER.PRIVACY_FORM.FIELDS.LEVEL' | translate }}
    </span>
    {{ currentUser?.details?.level }}
  </li>
  <li class="flex items-baseline">
    <span class="mr-2 font-semibold">
      {{ 'USER_PAGE.STEPPER.PRIVACY_FORM.FIELDS.FULL_NAME' | translate }}
    </span>
    {{ currentUser?.details?.firstName + ' ' + currentUser?.details?.lastName }}
  </li>
  <li class="flex items-baseline">
    <span class="mr-2 font-semibold">
      {{ 'USER_PAGE.STEPPER.PRIVACY_FORM.FIELDS.EMAIL' | translate }}
    </span>
    {{ currentUser?.details?.email }}
  </li>
</ul>
<p>
  {{
    'USER_PAGE.STEPPER.PRIVACY_FORM.TERMS_AND_CONDITIONS.DETAILS' | translate
  }}
</p>
